import { useState, useMemo, Fragment } from "react";
import _ from "lodash";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import InitDesignerModal from "./InitDesignerModal";
import { dataValidator } from "../../tools/dataValidator";
import ActionButton from "../Commons/ActionButton";

import { MdAdd, MdContentCopy, MdEdit, MdDelete, MdOutlineExpandLess, MdOutlineExpandMore } from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { getLabel, } from "../../tools/Dictionary";
import "./Init.css";

const InitDesigner = (props) => {

  //Props
  const IsDesktop = props.IsDesktop;
  const ReadOnly = props.ReadOnly || !props.Access.canWrite
  const OnCloseModal = props.OnCloseModal;
  const OnConfirm = props.OnConfirm;
  const Variable = useMemo(() =>
  {

    let toSortVariable = [...props.Variable.filter(v => v.variableTypeCode != "sensor")]

    toSortVariable.sort((a, b) =>
    {
      if (a.isParameter && !b.isParameter) return -1;
      if (!a.isParameter && b.isParameter) return 1;

      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;

      return 0;
    });

    return toSortVariable;

  }, [props.Variable]);



  //State
  const [init, setInit] = useState(props.Data || {
    script: [],
    isActive: true
  });
  const [error, setError] = useState({});
  const [modal, setModal] = useState({
    display: false,
    indexS: -1,
    indexC: -1
  });
  const [loading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Variables
  const operator = [
    "eq",
    "ne",
    "gt",
    "gte",
    "lt",
    "lte",
    "in",
    "notin"
  ];
  const actionOperator = [
    "assign"
  ]

  const onChangeIsActive = (e) => {


    setInit(init =>({
      ...init,
      isActive: !init.isActive
    }));

  };

  const findNextName = () => {

    let name = "Script ";
    let counter = 1;

    //Find the next available name
    // eslint-disable-next-line no-loop-func
    while (init.script.some(s => s.name === name + counter))
    {
      counter++;
    }

    return name + counter;

  };

  const orderScript = (_script) => {

    try{

      let currentOrder = 10;

      _script.forEach(s => {
        s.order = currentOrder;
        currentOrder += 10;
      });

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }



  };


  const onClickAddScript = (e) => {


    let name = findNextName();

    let order = 10;

    if (init.script[init.script.length - 1])
      order = init.script[init.script.length - 1].order + 10;

    setInit(init => ({
      ...init,
      script: [
        ...init.script,
        ...[{
         name,
         condition: [{
           variable: undefined,
           variableName: "",
           variableType: "",
           operator: "eq",
           value: "",
           order: 10
          }
         ],
        action: [{
            variable: undefined,
            variableName: "",
            variableType: "",
            operator: "assign",
            value: "",
            order: 10
          }
          ],
          display: true,
          order
        }]
      ]
    }));

  };


  const onChangeName = (e, _indexS) => {

    try
    {


      let toUpdateInit = _.cloneDeep(init);

      toUpdateInit.script[_indexS].name = e.target.value;



      setInit(toUpdateInit);

      onValidateField(toUpdateInit.script);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }
  };


  const onClickAddCondition = (e, indexS) => {

    try{


      let toUpdateInit = _.cloneDeep(init);

      let nextOrder = 10;

      if (toUpdateInit.script[indexS].condition[toUpdateInit.script[indexS].condition.length - 1])
        nextOrder = toUpdateInit.script[indexS].condition[toUpdateInit.script[indexS].condition.length - 1].order + 10;

      toUpdateInit.script[indexS].condition.push({
        variable: undefined,
        variableName: "",
        variableType: "",
        operator: "eq",
        value:"",
        order: nextOrder
      }); 

      setInit(toUpdateInit);

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });    

    }


  };


  const onDeleteLine = (_property, _indexS, _indexC) =>
  {

    try
    {


      let toUpdateInit = _.cloneDeep(init);

      toUpdateInit.script[_indexS][_property].splice(_indexC, 1);



      setInit(toUpdateInit);

      onValidateField(toUpdateInit.script);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onClickVariable = (_property, _indexS, _indexC) => {

    setModal({
      display: true,
      property: _property,
      indexS: _indexS,
      indexC: _indexC
    });

  };

  const onChangeVariable = (_variable) => {

    try
    {


      let toUpdateInit = _.cloneDeep(init);

      toUpdateInit.script[modal.indexS][modal.property][modal.indexC].variable = _variable._id;
      toUpdateInit.script[modal.indexS][modal.property][modal.indexC].variableName = _variable.name;
      toUpdateInit.script[modal.indexS][modal.property][modal.indexC].variableType = _variable.variableTypeCode;



      setInit(toUpdateInit);
      setModal({display: false});
      onValidateField(toUpdateInit.script);


    } catch (err)
    {

      console.log(err);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }



  };

  const onChangeOperator = (e, _indexS, _indexC) =>
  {

    try
    {


      let toUpdateInit = _.cloneDeep(init);

      toUpdateInit.script[_indexS].condition[_indexC].operator = e.target.value;



      setInit(toUpdateInit);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onChangeValue = (e, _property, _indexS, _indexC) =>
  {

    let toUpdateInit = _.cloneDeep(init);

    toUpdateInit.script[_indexS][_property][_indexC].value = e.target.value.replace(/,/g, '.');

    

    setInit(toUpdateInit);

    onValidateField(toUpdateInit.script);

  };

  const onClickAddAction = (e, indexS) =>
  {

    try
    {


      let toUpdateInit = _.cloneDeep(init);

      let nextOrder = 10;

      if (toUpdateInit.script[indexS].action[toUpdateInit.script[indexS].action.length - 1])
        nextOrder = toUpdateInit.script[indexS].action[toUpdateInit.script[indexS].action.length - 1].order + 10;

      toUpdateInit.script[indexS].action.push({
        variable: undefined,
        variableName: "",
        variableType: "",
        operator: "assign",
        value: "",
        order: nextOrder
      });

      setInit(toUpdateInit);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  };



  const onValidateField = (_script = undefined) =>
  {

    let currentError = {}; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];

    let isValid = true; // Flag to track overall validity

    let finalCheck = false;

    if (!_script) {
      finalCheck = true;
      _script = init.script;
    }

    _script.forEach((s, indexS) =>
    {

      //Name
      currentValidation = dataValidator([
        { field: indexS + "_name", value: s["name"], listValidation: ["required", "max:20"] }
      ]);

      Validation = [...Validation, ...currentValidation];

      //Condition
      s.condition.forEach((c, indexC) => {

        if (c.variableType){

          switch (c.variableType){
            case "number": 
              currentValidation = dataValidator([
                { field: indexS + "_" + indexC + "_value", value: c["value"], listValidation: ["required", "number", "max:1000"] }
              ]);   
              
              Validation = [...Validation, ...currentValidation];
              
              return;

            case "int":
              currentValidation = dataValidator([
                { field: indexS + "_" + indexC + "_value", value: c["value"], listValidation: ["required", "integer", "max:1000"] }
              ]);

              Validation = [...Validation, ...currentValidation];

              return;

            case "text":
              currentValidation = dataValidator([
                { field: indexS + "_" + indexC + "_value", value: c["value"], listValidation: ["max:1000"] }
              ]);

              Validation = [...Validation, ...currentValidation];

              return;

            default:
              return;


          }

        }

        if (c.value || finalCheck){

          currentValidation = dataValidator([
            { field: indexS + "_" + indexC + "_variable", value: c["variable"], listValidation: ["required"] }
          ]);

          Validation = [...Validation, ...currentValidation];

        }

      });

      //Actions
      s.action.forEach((a, indexA) =>
      {


        if (a.variableType)
        {

          switch (a.variableType)
          {
            case "number":
              currentValidation = dataValidator([
                { field: indexS + "_" + indexA + "_value_action", value: a["value"], listValidation: ["required", "number", "max:1000"] }
              ]);

              Validation = [...Validation, ...currentValidation];

              return;

            case "int":
              currentValidation = dataValidator([
                { field: indexS + "_" + indexA + "_value_action", value: a["value"], listValidation: ["required", "integer", "max:1000"] }
              ]);

              Validation = [...Validation, ...currentValidation];

              return;

            case "text":
              currentValidation = dataValidator([
                { field: indexS + "_" + indexA + "_value_action", value: a["value"], listValidation: ["max:1000"] }
              ]);

              Validation = [...Validation, ...currentValidation];

              return;

            default:
              return;
          }

        }

        if (a.value || finalCheck)
        {

          currentValidation = dataValidator([
            { field: indexS + "_" + indexA + "_variable_action", value: a["variable"], listValidation: ["required"] }
          ]);

          Validation = [...Validation, ...currentValidation];

        }

      });

    });

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });



    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag

  };

  const onClickDisplay = (_indexS) => {

    try
    {


      let toUpdateInit = _.cloneDeep(init);

      toUpdateInit.script[_indexS].display = !toUpdateInit.script[_indexS].display;



      setInit(toUpdateInit);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onClickDuplicate = (_indexS) => {


    try
    {

      let order = init.script[init.script.length - 1].order + 10;


      let toUpdateInit = _.cloneDeep(init);

      let toAddScript = _.cloneDeep(toUpdateInit.script[_indexS]);


      toUpdateInit.script.push(
        toAddScript
      );

      toUpdateInit.script[toUpdateInit.script.length - 1].name = findNextName();
      toUpdateInit.script[toUpdateInit.script.length - 1].order = order;




      setInit(toUpdateInit);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }  

  };


  const onClickMove = (_move, _indexS) =>
  {


    try
    {

     if (!init.script[_indexS + _move]) return;


      let toUpdateInit = _.cloneDeep(init);

      const [toMoveScript] = toUpdateInit.script.splice(_indexS, 1);
      toUpdateInit.script.splice(_indexS + _move, 0, toMoveScript);



      orderScript(toUpdateInit.script);



      setInit(toUpdateInit);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onClickDelete = (_indexS) => {  

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("InitDesigner", "Are you sure you want to delete this script?"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => onDelete(_indexS),
      Display: true
    }));

  };

  const onDelete = (_indexS) =>
  {


    try
    {

      setConfirm(confirm => ({ ...confirm, Display: false }));


      let toUpdateInit = _.cloneDeep(init);

      toUpdateInit.script.splice(_indexS, 1);

      orderScript(toUpdateInit.script);

      setInit(toUpdateInit);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onClickConfirm = () => {

    try{

      if (!onValidateField()) throw new Error(getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."));

      OnConfirm(init);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  };


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        {modal.display &&
          <InitDesignerModal 
            Variable={Variable}
            OnCloseModal={() => setModal({display: false})}
            OnChangeVariable={onChangeVariable}
          />
        }
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("InitDesigner", "Initialization script designer")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title" style={{width: "50%"}}>
              {getLabel("InitDesigner", "Active")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <label className="page_switch">
                <input
                  type="checkbox"
                  checked={init.isActive}
                  onChange={onChangeIsActive}
                  disabled={ReadOnly || loading}
                />
                <span className="page_slider round" />
              </label>
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title" style={{ width: "100%", textAlign: "center", justifyContent: "center" }}>
              {getLabel("InitDesigner", "Scripts")}
            </div>
          </div>
          {init.script.map((s, indexS) => (
            <div className="init_script_cont" key={indexS}>
                <div className="init_script_title_cont">
                  {s.display && !ReadOnly ? (
                    <Fragment>
                      <input
                        className={"page_text_input " + (error[indexS + "_name"] ? "auth_fill_row_input_error " : "")}
                        value={s.name || ""}
                        type="text"
                        style={{ width: "160px" }}
                        onChange={(e) => onChangeName(e, indexS)}
                        disabled={ReadOnly || loading}
                        title={error[indexS + "_name"] || ""}
                      />
                    </Fragment>
                  ):(
                    <Fragment>
                      {s.name}
                    </Fragment>
                  )}
                  {(!ReadOnly) &&
                  <Fragment>
                    <div className="page_button_round" style={{ marginLeft: "10px", marginTop: "0px", width: "26px", height: "26px", backgroundColor: "#0076a5", fontSize: "20px", borderRadius: "3px" }} title={getLabel("InitDesigner", "Duplicate this script")}
                      onClick={() => onClickDuplicate(indexS)}>
                      <MdContentCopy />
                    </div>
                    <div className="page_button_round" style={{ marginLeft: "10px", marginTop: "0px", width: "26px", height: "26px", backgroundColor: "#424849", fontSize: "20px", borderRadius: "3px" }} title={getLabel("InitDesigner", "Move down this script")}
                      onClick={() => onClickMove(1, indexS)}>
                      <MdOutlineExpandMore />
                    </div>
                    <div className="page_button_round" style={{ marginLeft: "10px", marginTop: "0px", width: "26px", height: "26px", backgroundColor: "#424849", fontSize: "20px", borderRadius: "3px" }} title={getLabel("InitDesigner", "Move up this script")}
                      onClick={() => onClickMove(-1, indexS)}>
                      <MdOutlineExpandLess />
                    </div>
                    <div className="page_button_round" style={{ marginLeft: "10px", marginTop: "0px", width: "26px", height: "26px", backgroundColor: "#b30000", fontSize: "20px", borderRadius: "3px" }} title={getLabel("InitDesigner", "Delete this script")}
                      onClick={() => onClickDelete(indexS)}>
                      <MdDelete />
                    </div>
                    {!s.display &&
                      <div className="init_script_cont_displaybutton">
                        <ActionButton
                          IsDesktop={IsDesktop}
                          Label={getLabel("InitDesigner", "Display this script content")}
                          Icon={FaEye}
                          Disabled={loading}
                          OnClick={() => onClickDisplay(indexS)}
                          style={{width: "300px"}}
                          buttonStyle={{ fontSize: "80%", marginRight: "10px", backgroundColor: "#60a641", width: "300px" }}
                          iconStyle={{ backgroundColor: "#549339" }}
                        />
                      </div>
                    }
                    
                  </Fragment>
                  }
                  
                  {s.display &&
                    <div className="init_script_delete_cont">
                      <div className="page_button_round" style={{ marginLeft: "10px", marginTop: "0px", width: "26px", height: "26px", backgroundColor: "#60a641", fontSize: "20px", borderRadius: "3px" }} 
                        title={getLabel("InitDesigner", s.display ? "Hide this script content" : "Display this script content")}
                        onClick={() => onClickDisplay(indexS)}>
                        {s.display ? <FaEyeSlash /> : <FaEye />}
                      </div>
                    </div>
                  }

                  
                </div>
              {s.display && 
                <div className="init_script_conditon_cont">
                  <div className="init_script_conditon_title">
                    {getLabel("InitDesigner", "Condition(s)")}
                    {(!ReadOnly) &&
                    <div className="page_button_round" style={{ marginLeft: "10px", marginTop: "2px", width: "26px", height: "26px", backgroundColor: "#0076a5" }} title={getLabel("InitDesigner", "Add condition")} 
                        onClick={(e) => onClickAddCondition(e, indexS)}>
                        <MdAdd />
                      </div>
                    }
                  </div>
                  {s.condition.map((c, indexC) => (
                    <div className="init_script_conditon_row" key={indexC} >
                      <div className="init_script_conditon_row_cont_data" style={{ border: "1px solid #4c71b1" }}>
                        <div className="init_script_conditon_row_value" onClick={() => onClickVariable("condition", indexS, indexC)}>
                          <div className="init_script_conditon_row_value_icon">
                            {(!ReadOnly) &&
                              <div className="page_button_round" style={{ marginRight: "5px", width: "30px", height: "30px", fontSize: "26px", borderRadius: "8px" }} title={getLabel("InitDesigner", "Choose a variable")} onClick={() => onClickVariable("condition", indexS, indexC)}>
                                <MdEdit />
                              </div>
                            }
                          </div>
                          <div className={"init_script_conditon_row_value_text " + (error[indexS + "_" + indexC + "_variable"] ? "init_script_conditon_row_value_text_error " : "")} >
                            {c.variableName || getLabel("InitDesigner", "Choose a variable")}
                          </div>
                        </div>
                        <div className="init_script_conditon_row_operator">
                          <select
                            value={c.operator}
                            className={"page_select_input " + (error[indexS + "_" + indexC + "_operator"] ? "auth_fill_row_input_error " : "")}
                            onChange={(e) => onChangeOperator(e, indexS, indexC)}
                            style={{ width: "200px", textAlign: "center", color: "black" }}
                            disabled={loading || ReadOnly}
                          >
                            {operator.map((o, index) => (
                              <option key={index} value={o} style={{ textAlign: "center", color: "black" }}>
                                {getLabel("ConditionDesigner", o)}
                              </option>
                            ))}
                          </select>  
                        </div>
                        <div className="init_script_conditon_row_value">
                          <div className="init_script_conditon_row_value_text">
                            <input
                              className={"page_text_input " + (error[indexS + "_" + indexC + "_value"] ? "auth_fill_row_input_error " : "")}
                              value={c.value || ""}
                              type="text"
                              style={{ width: "100%" }}
                              onChange={(e) => onChangeValue(e, "condition", indexS, indexC)}
                              disabled={ReadOnly || loading}
                              title={error[indexS + "_" + indexC + "_value"] || ""}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="init_script_conditon_row_cont_action">
                        {(!ReadOnly && indexC > 0) &&
                          <div className="page_button_round" style={{ width: "30px", height: "30px", fontSize: "26px", borderRadius: "8px", backgroundColor: "#b30000" }} title={getLabel("InitDesigner", "Delete this condition")} onClick={() => onDeleteLine("condition", indexS, indexC)}>
                            <MdDelete />
                          </div>
                        }
                      </div>
                    </div>
                  ))}

                </div>
              }
              {s.display && 
                <div className="init_script_conditon_cont">
                  <div className="init_script_conditon_title">
                    {getLabel("InitDesigner", "Action(s)")}
                    {(!ReadOnly) &&
                    <div className="page_button_round" style={{ marginLeft: "10px", marginTop: "2px", width: "26px", height: "26px", backgroundColor: "#0076a5" }} title={getLabel("InitDesigner", "Add an action")} 
                        onClick={(e) => onClickAddAction(e, indexS)}>
                        <MdAdd />
                      </div>
                    }
                  </div>
                  {s.action.map((a, indexA) => (
                    <div className="init_script_conditon_row" key={indexA} >
                      <div className="init_script_conditon_row_cont_data" style={{ border: "1px solid #60a641" }}>
                        <div className="init_script_conditon_row_value" onClick={() => onClickVariable("action", indexS, indexA)}>
                          <div className="init_script_conditon_row_value_icon">
                            {(!ReadOnly) &&
                              <div className="page_button_round" style={{ marginRight: "5px", width: "30px", height: "30px", fontSize: "26px", borderRadius: "8px" }} title={getLabel("InitDesigner", "Choose a variable")} onClick={() => onClickVariable("action", indexS, indexA)}>
                                <MdEdit />
                              </div>
                            }
                          </div>
                          <div className={"init_script_conditon_row_value_text " + (error[indexS + "_" + indexA + "_variable_action"] ? "init_script_conditon_row_value_text_error " : "")} >
                            {a.variableName || getLabel("InitDesigner", "Choose a variable")}
                          </div>
                        </div>
                        <div className="init_script_conditon_row_operator">
                          <select
                            value={a.operator}
                            className={"page_select_input " + (error[indexS + "_" + indexA + "_operator_action"] ? "auth_fill_row_input_error " : "")}
                            onChange={(e) => onChangeOperator(e, indexS, indexA)}
                            style={{ width: "200px", textAlign: "center", color: "black" }}
                            disabled={loading || ReadOnly}
                          >
                            {actionOperator.map((o, index) => (
                              <option key={index} value={o} style={{ textAlign: "center", color: "black" }}>
                                {getLabel("InitDesigner", o)}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="init_script_conditon_row_value">
                          <div className="init_script_conditon_row_value_text">
                            <input
                              className={"page_text_input " + (error[indexS + "_" + indexA + "_value_action"] ? "auth_fill_row_input_error " : "")}
                              value={a.value || ""}
                              type="text"
                              style={{ width: "100%" }}
                              onChange={(e) => onChangeValue(e, "action", indexS, indexA)}
                              disabled={ReadOnly || loading}
                              title={error[indexS + "_" + indexA + "_value_action"] || ""}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="init_script_conditon_row_cont_action">
                        {(!ReadOnly && indexA > 0) &&
                          <div className="page_button_round" style={{ width: "30px", height: "30px", fontSize: "26px", borderRadius: "8px", backgroundColor: "#b30000" }} title={getLabel("InitDesigner", "Delete this condition")} onClick={() => onDeleteLine("action", indexS, indexA)}>
                            <MdDelete />
                          </div>
                        }
                      </div>
                    </div>
                  ))}
                </div>
              }
            </div>
          ))}
          <div className="init_script_action_cont">
            {(!ReadOnly) &&
              <div className="page_button_round" style={{marginTop: "10px"}} title={getLabel("InitDesigner", "Add script")} onClick={onClickAddScript}>
                <MdAdd />
              </div>
            }
          </div>

        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {!ReadOnly &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Confirm")}
              style={{ maxWidth: "200px" }}
              onClick={(loading) ? undefined : onClickConfirm}
              disabled={loading}
            />
          }
        </div>
      </div>
    </div>
  );

};

export default InitDesigner